import { DateTime } from 'luxon'

export class PaymentToken {
	public id: number
	public accountId: number
	public type: 'card' | 'sepa'
	public isDefault: boolean
	public active: boolean
	public expiresAt: DateTime | null
	public createdAt: DateTime
	public updatedAt: DateTime
	public paymentInfo?: PaymentInfo

	constructor(data: {
		id: number
		accountId: number
		type: 'card' | 'sepa'
		isDefault: boolean
		active: boolean
		expiresAt: DateTime | null
		createdAt: DateTime
		updatedAt: DateTime
		paymentInfo?: PaymentInfo
	}) {
		this.id = data.id
		this.accountId = data.accountId
		this.type = data.type
		this.isDefault = data.isDefault
		this.active = data.active
		this.expiresAt = data.expiresAt
		this.createdAt = data.createdAt
		this.updatedAt = data.updatedAt
		this.paymentInfo = data.paymentInfo
	}
}

export class PaymentInfo {
	public card?: CardInfo
	public sepa?: SepaInfo

	constructor(data: { card?: CardInfo; sepa?: SepaInfo }) {
		this.card = data.card
		this.sepa = data.sepa
	}
}

export class CardInfo {
	public brand: string
	public last4: string
	public expMonth: number
	public expYear: number

	constructor(data: {
		brand: string
		last4: string
		expMonth: number
		expYear: number
	}) {
		this.brand = data.brand
		this.last4 = data.last4
		this.expMonth = data.expMonth
		this.expYear = data.expYear
	}
}

export class SepaInfo {
	public iban: string
	public accountHolderName: string
	public accountHolderEmail: string

	constructor(data: {
		iban: string
		accountHolderName: string
		accountHolderEmail: string
	}) {
		this.iban = data.iban
		this.accountHolderName = data.accountHolderName
		this.accountHolderEmail = data.accountHolderEmail
	}
}
